export enum RydeProcessTitle {
  BulkImport = "BulkImport",
  BulkUpdate = "BulkUpdate",
  BulkArchive = "BulkArchive",
  BulkSendToSupplier = "BulkSendToSupplier",
  BulkRideCancel = "BulkRideCancel",
  BulkRideReject = "BulkRideReject",
  BulkRideStatusNew = "BulkRideStatusNew",
  BulkRideStatusDone = "BulkRideStatusDone",
  BulkRideStatusDoneApproved = "BulkRideStatusDoneApproved",
  BulkRideStatusReceived = "BulkRideStatusReceived",
  BulkRideRebuildRoute = "BulkRideRebuildRoute",
  BulkRecalculatePrice = "BulkRecalculatePrice",
  BulkRecalculateSupplierPrice = "BulkRecalculateSupplierPrice",
  BulkRideClone = "BulkRideClone",
  BulkJourneyClone = "BulkJourneyClone",
  BulkJourneyAssign = "BulkJourneyAssign",
  BulkRideSendSMS = "BulkRideSendSMS",
  BulkFetchTrackingHistory = "BulkFetchTrackingHistory",
  BulkFitVehicleAndRecalculate = "BulkFitVehicleAndRecalculate",
  BulkUpdateNotificationAsRead = "BulkUpdateNotificationAsRead",
  BulkUpdateNotificationResolved = "BulkUpdateNotificationResolved",
  BulkUpdateBasePrice = "BulkUpdateBasePrice",
  BulkCancelBookings = "BulkCancelBookings",
  BulkCloneBookings = "BulkCloneBookings",
  BulkSetPassengersNearBy = "BulkSetPassengersNearBy",
  BulkRecalculateWalkingDistance = "BulkRecalculateWalkingDistance",
  BulkActivateShiftTemplate = "BulkActivateShiftTemplate",
  CopyToSupplierPriceRates = "CopyToSupplierPriceRates",
  BulkRideRebuild = "BulkRideRebuild",
  BulkRideUpdateStations = "BulkRideUpdateStations",
  BulkFindArea = "BulkFindArea",
  CourseDeepRecalculate = "CourseDeepRecalculate",

  // ADMIN-PROCESSES
  BackupRestore = "BackupRestore",
  BackupCreate = "BackupCreate",
}

export enum ProcessStatusEnum {
  Pending = "Pending",
  Completed = "Completed",
  Failed = "Failed",
}

export const finishedProcessTypes = [
  ProcessStatusEnum.Failed,
  ProcessStatusEnum.Completed,
];
